// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "46e96b3fe9ea231d726a0afe656260cd92db11d0/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};